import { ImageMagnifier } from "@common-components/cards/MonitorCard";
import { useFetch } from "@hooks/useAuthApi";
import CCP_API from "api/ccpAPi";
import React from "react";
import InnerImageZoom from "react-inner-image-zoom";
import "react-inner-image-zoom/lib/InnerImageZoom/styles.css";

const imageCCPData = [
  { id: 1, src: "ccp-img1.png" },
  { id: 2, src: "ccp-img1.png" },
  { id: 3, src: "ccp-img1.png" },
  { id: 4, src: "ccp-img1.png" },
  { id: 5, src: "ccp-img1.png" },
  { id: 6, src: "ccp-img1.png" },
];

const CCP_ImageCards = ({ images }) => {
  console.log(images);
  return (
    <>
      <div className="flex items-center justify-start rounded-md border space-2 bg-gray-50 overflow-hidden dark-bg p-3">
        {images?.map((image) => {
          console.log(image.imageURL);
          return (
            <div
              key={image.id}
              className="lg:w-[32%] w-auto h-fit"
            >
              <ImageMagnifier
                src={image.imageURL}
                width={300}
                height={300}
                magnifierHeight={400}
                magnifierWidth={400}
                zoomLevel={2}
                alt={image.imageURL}
                isPlaying={false}
              />
            </div>
          );
        })}
      </div>
    </>
  );
};

export default CCP_ImageCards;
